/* Rune V2 enterprise runtime.
   Markup carries the visual design; this engine owns accessible state,
   the free cast, current-market prices and the single Shopify checkout path.
   No innerHTML with user text anywhere. */
(function () {
  'use strict';
  if (!document.querySelector('[data-rv2-page]')) return;

  var LOCALE = String(document.documentElement.lang || 'en').toLowerCase();
  var LANG = LOCALE.split('-')[0];
  var I18N = window.DeckauraRuneV2Translations || {};
  function t(value) { return I18N[value] || value; }
  function tf(value, replacements) {
    var output = t(value);
    Object.keys(replacements || {}).forEach(function (key) {
      output = output.split('{' + key + '}').join(String(replacements[key]));
    });
    return output;
  }
  var MARKET_COPY = {
    en:{checking:'Checking your local price…',unavailable:'Local prices could not be verified. Nothing can be added; retry when your connection is stable.',retry:'Retry local prices',cartMismatch:'The cart did not match the signed price. The item was removed and local prices are refreshing. Select the refreshed package and continue again.'},
    es:{checking:'Comprobando tu precio local…',unavailable:'No se pudieron verificar los precios locales. No se puede añadir nada; vuelve a intentarlo cuando la conexión sea estable.',retry:'Reintentar precios locales',cartMismatch:'El carrito no coincidió con el precio firmado. Se eliminó el artículo y se están actualizando los precios locales. Elige el paquete actualizado y continúa de nuevo.'},
    de:{checking:'Dein lokaler Preis wird geprüft…',unavailable:'Die lokalen Preise konnten nicht bestätigt werden. Es kann nichts hinzugefügt werden; versuche es bei stabiler Verbindung erneut.',retry:'Lokale Preise erneut prüfen',cartMismatch:'Der Warenkorb stimmte nicht mit dem signierten Preis überein. Der Artikel wurde entfernt und die lokalen Preise werden aktualisiert. Wähle das aktualisierte Paket und fahre erneut fort.'},
    tr:{checking:'Yerel fiyatın kontrol ediliyor…',unavailable:'Yerel fiyatlar doğrulanamadı. Şu anda hiçbir şey eklenemez; bağlantın kararlı olduğunda yeniden dene.',retry:'Yerel fiyatları yeniden dene',cartMismatch:'Sepet imzalı fiyatla eşleşmedi. Ürün kaldırıldı ve yerel fiyatlar yenileniyor. Yenilenen paketi seçip yeniden devam et.'},
    pt:{checking:'A verificar o teu preço local…',unavailable:'Não foi possível verificar os preços locais. Nada pode ser adicionado; tenta novamente quando a ligação estiver estável.',retry:'Tentar novamente os preços locais',cartMismatch:'O carrinho não correspondeu ao preço assinado. O item foi removido e os preços locais estão a ser atualizados. Escolhe o pacote atualizado e continua novamente.'}
  };
  function marketText(key) { var copy = MARKET_COPY[LOCALE] || MARKET_COPY[LANG] || MARKET_COPY.en; return copy[key] || MARKET_COPY.en[key]; }

  /* ------------ design data tables ------------ */
  var RUNES = [
    ['ᚠ','Fehu','Earned gain and what it costs to keep','What was gained is leaking away'],
    ['ᚢ','Uruz','Raw strength, health, untamed drive','Force applied in the wrong place'],
    ['ᚦ','Thurisaz','A gate with friction on it','Reaction moving faster than thought'],
    ['ᚨ','Ansuz','A message arriving, a signal to read','Words landing wrong, or not landing'],
    ['ᚱ','Raidho','Movement, travel, a route already chosen','Progress stalled, the route in question'],
    ['ᚲ','Kenaz','Clarity, craft, seeing the mechanism','Something is still being kept from view'],
    ['ᚷ','Gebo','An exchange, a gift with a return','Giving and receiving out of balance'],
    ['ᚹ','Wunjo','Alignment, ease, being in the right place','Satisfaction delayed, not denied'],
    ['ᚺ','Hagalaz','Disruption arriving from outside you','Weather you cannot argue with'],
    ['ᚾ','Nauthiz','A constraint that teaches something','Resistance to the lesson in the need'],
    ['ᛁ','Isa','Stillness, a hold, nothing to force','The hold is thawing, but not on your schedule'],
    ['ᛃ','Jera','Harvest in its own season','A cycle counted before it closed'],
    ['ᛇ','Eihwaz','Endurance and the long view','Avoiding what has to be faced'],
    ['ᛈ','Perthro','A variable still face down','Secrecy, information withheld'],
    ['ᛉ','Algiz','Protection and a clean boundary','A boundary left open'],
    ['ᛊ','Sowilo','Visibility, momentum in the open','Bright light burning the wrong fuel'],
    ['ᛏ','Tiwaz','Commitment, a fair and named decision',"A decision made for someone else's reason"],
    ['ᛒ','Berkano','Growth, a beginning with roots','A beginning made too early'],
    ['ᛖ','Ehwaz','Partnership actually in motion','Two paces that do not match'],
    ['ᛗ','Mannaz','The self, and how you are being read','A story you are telling yourself'],
    ['ᛚ','Laguz','Feeling, intuition, what flows','Being carried by feeling'],
    ['ᛜ','Ingwaz','A seed set, work under the surface','Potential held, not released'],
    ['ᛞ','Dagaz','A turning point, daylight on it','A shift real but not yet visible'],
    ['ᛟ','Othala','Inheritance, home, what you keep','Holding what should be handed on']
  ];
  var NON_REVERSIBLE = { 6:true, 8:true, 9:true, 10:true, 11:true, 12:true, 15:true, 21:true, 22:true };
  var FOCI = [
    { id:'love', label:'Love & Relationships', glyph:'ᛒ', hint:'Connection, communication, reconciliation', hue:'#6B4463' },
    { id:'decision', label:'A Decision', glyph:'ᛏ', hint:'Stay, leave, contact, wait', hue:'#35566B' },
    { id:'career', label:'Career & Purpose', glyph:'ᚱ', hint:'Work, an offer, direction', hue:'#1F5E5E' },
    { id:'pattern', label:'A Repeating Pattern', glyph:'ᛇ', hint:'What keeps happening, and why', hue:'#55602F' },
    { id:'change', label:"What's Changing Now", glyph:'ᛞ', hint:'The next phase or turning point', hue:'#9C5A22' },
    { id:'self', label:'Self & Identity', glyph:'ᛗ', hint:'Confidence, boundaries, personal direction', hue:'#2F5D45' },
    { id:'other', label:'Something else', glyph:'ᛈ', hint:'General guidance on an open situation', hue:'#5B5145' }
  ];
  var ANSWERS = [
    { id:'focused', label:'A focused answer', spread:3, kind:'focused', note:'3-rune focused spread' },
    { id:'compare', label:'Compare two paths', spread:5, kind:'crossroads', note:'5-rune crossroads spread' },
    { id:'hidden', label:'Understand the hidden pattern', spread:5, kind:'pattern', note:'5-rune pattern spread' },
    { id:'compass', label:'Get a 30-day direction', spread:5, kind:'compass', note:'5-rune compass spread' }
  ];
  var SLOTS = {
    focused:['Anchor','Gate','Direction'],
    crossroads:['Anchor','Path A','Path B','Gate','Move'],
    pattern:['Root','Now','Obstacle','Support','Direction'],
    compass:['Now','Gate','Move','Watch','Direction']
  };
  var SLOT_IDS = {
    focused:['anchor','gate','direction'],
    crossroads:['anchor','path_a','path_b','gate','move'],
    pattern:['root','now','obstacle','support','direction'],
    compass:['now','gate','move','watch','direction']
  };
  var TIMEFRAMES = ['This week','Next 30 days','Next 3 months','No fixed timeframe'];
  var TIMEFRAME_IDS = {
    'This week':'this_week',
    'Next 30 days':'next_30_days',
    'Next 3 months':'next_3_months',
    'No fixed timeframe':'no_fixed_timeframe'
  };
  var TIER_NAMES = ['Essential','Focused','In-Depth'];
  var ACCENT = ['#E6E1EC','#E3C98F','#E3C98F'];
  var TIER_BASE = [
    { price:'—', priceCents:0, available:false, wm:'ᚨ', bestFor:'Best for one focused question', words:'450+ words',
      features:['Your exact cast applied to your question','The strongest signal, named','The deciding condition','One grounded next move'] },
    { price:'—', priceCents:0, available:false, wm:'ᛏ', bestFor:'Best for deciding between two paths', words:'750+ words',
      features:['Everything in Essential','The hidden pattern and central tension','Path A vs Path B','What strengthens and weakens each direction','A grounded 7-day plan'] },
    { price:'—', priceCents:0, available:false, wm:'ᛃ', bestFor:'Best for a complete 30-day direction', words:'1,250+ words',
      features:['Everything in Focused','Risks, support and timing windows','Up to two related sub-questions','Four weekly checkpoints','Free 7-day rune recheck'] }
  ];
  var TABLE = [
    ['Exact-question interpretation',1,1,1],
    ['The deciding condition',1,1,1],
    ['Hidden pattern and tension',0,1,1],
    ['Path A vs Path B',0,1,1],
    ['7-day action plan',0,1,1],
    ['30-day weekly checkpoints',0,0,1],
    ['Free 7-day recheck',0,0,1]
  ];
  var REFLECT = {
    love:'Where in this connection are you waiting for permission you could give yourself?',
    decision:'Which option are you defending, and which one are you actually drawn to?',
    career:'What would you need to see in the next two weeks to feel settled either way?',
    pattern:'What is the earliest moment you can recognise this pattern starting?',
    change:'What are you still treating as permanent that has already shifted?',
    self:'Which version of yourself are you protecting, and from whom?',
    other:'What would change if you stopped waiting for more information?'
  };
  var STEP = {
    love:'For the next three days, note what happens when you do not initiate. Record it, do not interpret it yet.',
    decision:'Write both options as one sentence each. The one that needs a paragraph to defend is the one you doubt.',
    career:'Name the single condition that would make staying clearly right, then watch for it this month.',
    pattern:'Pick the earliest point in the pattern you can still influence, and change one small thing there.',
    change:'List what has already changed without your input, and plan around that list instead of the old version.',
    self:'Say the thing you want out loud once, to yourself, before you say it to anyone else.',
    other:'Choose the smallest step you could take this week that you would not need to undo.'
  };
  /* The free result ends on this question; the same text is sent as the snapshot's curiosityQuestion. */
  var OPEN_Q = {
    love:'Would reaching out now create clarity, or add resistance?',
    decision:'Is acting now a decision, or a reaction to the waiting?',
    career:'Do the better terms come from staying, or from moving on?',
    pattern:'Is this pattern repeated by circumstance, or by your response to it?',
    change:'Does the shift already underway need your push, or only your patience?',
    self:'Is the change you want a new direction, or an older one you set down?',
    other:'Is the missing piece more information, or a decision?'
  };
  /* Most visitors never open Refine, so focus stays 'other'; the spread (detected from the question) picks the hook then. */
  var OPEN_Q_KIND = {
    focused:'What is the one condition this outcome depends on?',
    crossroads:'Which of the two paths holds up once the deciding condition is clear?',
    pattern:'What keeps this pattern in place, and where can it break?',
    compass:'What should you watch for over the next 30 days?'
  };
  var QPH = {
    love:'e.g. Should I reach out to him, or let this settle first?',
    decision:'e.g. Do I accept the offer, or hold out for the other one?',
    career:'e.g. Is it time to leave my current role?',
    pattern:'e.g. Why do I keep ending up in the same argument?',
    change:'e.g. What is this unsettled phase actually moving toward?',
    self:'e.g. Why does my confidence drop right when things go well?',
    other:'e.g. What do I most need to understand about this situation?'
  };
  var REVIEWS = [
    { quote:'It did not tell me what I wanted to hear. It helped me understand why waiting was actually the stronger choice.', who:'M. · Verified buyer', tier:'Focused' },
    { quote:'I wanted to know where this ends up and when. I got a window and a list of things to watch for, instead of a date that was never going to be true.', who:'E. · Verified buyer', tier:'In-Depth' },
    { quote:'It used my own words back at me, which is why it landed. Nothing generic, nothing dramatic.', who:'A. · Verified buyer', tier:'Essential' }
  ];
  var FAQS = [
    ['How is my reading created?', null],
    ['When and how will I receive it?', null],
    ['Is this a subscription?','No. Every reading is a one-time purchase. There are no credits, no recurring charge and no account to cancel.'],
    ['Can I change my question after paying?','Yes, until the reading is written. Reply to your order confirmation and the new question replaces the old one.'],
    ['Can I ask about another person?','You can ask about your own situation with someone. We do not claim access to anyone else’s private thoughts or feelings, and we will not write as if we do.'],
    ['Does it predict exact dates or guaranteed outcomes?','No. You get timing windows and the conditions that shift them, so you know what to watch rather than what to wait for.'],
    ['What if my reading does not arrive?','Reply to your order email and we will resend the reading link. If it still cannot be delivered, the order is refunded.'],
    ['How is my question stored?','It is stored with your order so your reading can be written and re-sent. It is never published, never shown on the site and never used in advertising.']
  ];
  var API_BASE = 'https://reading.deckaura.com/api/rune';
  var RAIL_TIERS = ['essential','deeper','indepth'];
  var RUNE_VARIANTS = [53782500213009,53782500245777,53782500278545];
  var RUNE_SKUS = ['READING-DEEP','READING-MEDIUM','READING-PREMIUM'];
  var MIN_QUESTION = 8;
  var MARKET_CURRENCY = '';
  var MARKET_COUNTRY = '';
  var SHARED_FUNNEL_VERSION = 'enterprise-shared-tools-2026-08-v1';
  var RUNE_PRESENTATION_VERSION = 'rune-v2-direct-v1';
  var INTENT_ENDPOINT = 'https://reading.deckaura.com/api/readings/intent';
  var STATE_KEY = 'rv2_state_v3:' + LOCALE;

  /* ------------ state ------------ */
  var s = {
    mobile: !window.matchMedia('(min-width:760px)').matches,
    focus: null, answer: 'focused', auto: true, timeframe: 'No fixed timeframe',
    question: '', cast: [], casting: false, editing: false, tier: null, tierAuto: false,
    openFaqs: { 0: true, 1: true }, server: null, readingId: '', castQuestion: '', castContract: '', busy: false,
    validationShown: false, checkoutBusy: false, marketReady: false, marketError: false
  };
  function persistedState() {
    return {
      focus: s.focus, answer: s.answer, auto: !!s.auto, timeframe: s.timeframe,
      question: s.question, cast: s.cast, editing: !!s.editing, tier: s.tier, tierAuto: !!s.tierAuto,
      server: s.server, readingId: s.readingId, castQuestion: s.castQuestion,
      castContract: s.castContract
    };
  }
  function persistState() {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(persistedState())); } catch (_) {}
  }
  function clearPersistedState() {
    try { sessionStorage.removeItem(STATE_KEY); } catch (_) {}
  }
  function castIsRestorable(cast) {
    if (!Array.isArray(cast) || cast.length > 5) return false;
    var seen = {};
    return cast.every(function (rune) {
      if (!rune || !Number.isInteger(rune.i) || !RUNES[rune.i] || typeof rune.rev !== 'boolean') return false;
      if (rune.rev && NON_REVERSIBLE[rune.i]) return false;
      if (seen[rune.i]) return false;
      seen[rune.i] = true;
      return true;
    });
  }
  function restoreState() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null');
      if (!saved || typeof saved !== 'object') return;
      if (saved.focus === null || FOCI.some(function (f) { return f.id === saved.focus; })) s.focus = saved.focus;
      if (ANSWERS.some(function (a) { return a.id === saved.answer; })) s.answer = saved.answer;
      if (TIMEFRAMES.indexOf(saved.timeframe) !== -1) s.timeframe = saved.timeframe;
      s.auto = saved.auto !== false;
      s.question = typeof saved.question === 'string' ? saved.question.slice(0, 220) : '';
      s.cast = castIsRestorable(saved.cast) ? saved.cast : [];
      s.editing = !!saved.editing;
      s.tier = Number.isInteger(saved.tier) && saved.tier >= 0 && saved.tier < 3 ? saved.tier : null;
      s.tierAuto = s.tier !== null && saved.tierAuto === true;
      s.server = saved.server && typeof saved.server === 'object' ? saved.server : null;
      s.readingId = typeof saved.readingId === 'string' ? saved.readingId : '';
      s.castQuestion = typeof saved.castQuestion === 'string' ? saved.castQuestion : '';
      s.castContract = typeof saved.castContract === 'string' ? saved.castContract : '';
      if (s.cast.length !== answerObj().spread || s.castContract !== castInputContract()) {
        s.cast = []; s.server = null; s.tier = null; s.readingId = ''; s.castQuestion = ''; s.castContract = '';
      }
    } catch (_) { clearPersistedState(); }
  }
  window.matchMedia('(min-width:760px)').addEventListener('change', function (e) {
    s.mobile = !e.matches; render();
  });
  function seed(text) {
    var n = 0;
    for (var i = 0; i < text.length; i++) n = (n * 31 + text.charCodeAt(i)) >>> 0;
    return n || 7;
  }
  function shortQ() {
    var q = (s.question || '').trim();
    if (!q) return '';
    return q.length > 46 ? q.slice(0, 46).trim() + '…' : q;
  }
  function answerObj() {
    for (var i = 0; i < ANSWERS.length; i++) if (ANSWERS[i].id === s.answer) return ANSWERS[i];
    return ANSWERS[0];
  }
  function names() { return TIER_NAMES.map(t); }
  function focusLabelText() {
    for (var i = 0; i < FOCI.length; i++) if (FOCI[i].id === s.focus) return t(FOCI[i].label);
    return t('General guidance');
  }
  function questionComparesPaths(question) {
    var q = (question || '').trim().toLowerCase();
    return /\s(?:or|versus|vs\.?|oder|veya|yoksa|ou)\s+\S|\sya\s+da\s+\S/.test(q) || (LANG === 'es' && /\so\s+\S/.test(q));
  }
  function recommendIndex() {
    var q = (s.question || '').toLowerCase();
    var a = s.answer;
    if (a === 'compass') return 2;
    if (a === 'hidden' || /(why|repeating|keeps happening|always)/.test(q)) return 2;
    if (a === 'compare' || questionComparesPaths(q)) return 1;
    return 0;
  }
  function autoAnswerId() {
    var q = (s.question || '').toLowerCase();
    if (/(why|repeating|keeps happening|always|blocked|pattern|neden|niçin|hep|tekrar|örüntü|warum|immer|wieder|muster|por qué|porque|siempre|repite|patr[oó]n|por que|repete|padr[aã]o)/.test(q)) return 'hidden';
    if (s.timeframe === 'Next 30 days' || /30 days|next month|30 gün|gelecek ay|nächsten? monat|30 tage|próximo mes|30 días|próximo mês|30 dias/.test(q)) return 'compass';
    if (/(\bor\b|\boder\b|\bveya\b|\bya da\b|\bou\b|\bo\b|should i|stay|leave|contact|wait|choose|accept|kalmalı|ayrılmalı|beklemeli|seçmeli|bleiben|gehen|warten|elegir|quedar|salir|esperar|escolher|ficar|sair)/.test(q)) return 'compare';
    return 'focused';
  }
  function questionIsValid() {
    return (s.question || '').trim().length >= MIN_QUESTION;
  }
  /* The question or a refinement changed after the cast: checkout would be refused, so the buttons reveal again. */
  function castIsStale() {
    return s.cast.length > 0 && !s.casting && s.castContract !== castInputContract();
  }
  function castInputContract() {
    return [
      (s.question || '').trim().toLowerCase(),
      s.focus || 'other',
      answerObj().kind,
      s.timeframe
    ].join('|');
  }
  function recommendationBadge(index) {
    if (index !== recommendIndex()) return '';
    var q = (s.question || '').trim().toLowerCase();
    if (s.answer === 'compass') return t('Recommended because you chose a 30-day direction reading.');
    if (s.answer === 'hidden') return t('Recommended because you chose a hidden-pattern reading.');
    if (/(why|repeating|keeps happening|always)/.test(q)) {
      return t('Recommended because your question asks about a repeating pattern.');
    }
    if (s.answer === 'compare') return t('Recommended because you chose to compare two paths.');
    if (questionComparesPaths(q)) {
      return t('Recommended because your question compares two possible paths.');
    }
    return t('Recommended for one focused question.');
  }
  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }
  function formatMarketMoney(cents, currency) {
    var amount = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, maximumFractionDigits: currency === 'JPY' ? 0 : 2
      }).format(amount);
    } catch (_) {
      return currency + ' ' + amount.toFixed(2);
    }
  }
  function plainText(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function firstSentence(value) {
    var text = plainText(value);
    var match = text.match(/^.+?[.!?…](?=\s|$)/);
    return match ? match[0] : text;
  }
  function centralRune(cast) {
    /* The gate slot, never Path A: naming one path as the tone-setter would favour it in a two-path cast. */
    var gate = (SLOT_IDS[answerObj().kind] || []).indexOf('gate');
    if (gate !== -1 && gate < cast.length) return gate;
    return cast.length > 2 ? 1 : 0;
  }
  function themeText(cast) {
    if (!cast.length) return '';
    var index = centralRune(cast);
    var c = cast[index];
    var slot = t((SLOTS[answerObj().kind] || SLOTS.pattern)[index] || '') || tf('Rune {number}', { number: index + 1 });
    return tf('{rune} in the {slot} position sets the tone of this cast.', {
      rune: RUNES[c.i][1] + (c.rev ? ' ' + t('reversed') : ''), slot: slot
    });
  }
  function openQuestionText() {
    var teaser = s.server && s.server.teaser ? plainText(s.server.teaser) : '';
    var single = teaser && teaser.length >= 12 && teaser.length <= 200 && !/[.!?…]\s+\S/.test(teaser);
    if (single && LANG === 'en' && /^whether\s/i.test(teaser)) return 'W' + teaser.slice(1).replace(/[.\s]+$/, '') + '?';
    if (single && /\?$/.test(teaser)) return teaser.charAt(0).toUpperCase() + teaser.slice(1);
    if (s.focus && s.focus !== 'other' && OPEN_Q[s.focus]) return t(OPEN_Q[s.focus]);
    return t(OPEN_Q_KIND[answerObj().kind] || OPEN_Q.other);
  }
  function runeMeaning(c) {
    var source = c.rev ? RUNES[c.i][3] : RUNES[c.i][2];
    if (I18N[source]) return I18N[source];
    if (LANG === 'en') return source;
    return tf('{rune} is {orientation} here; its role is interpreted through this position and the full cast below.', {
      rune: RUNES[c.i][1], orientation: c.rev ? t('reversed') : t('upright')
    });
  }
  function extractTwoPaths(question) {
    var raw = String(question || '').trim().replace(/[?!.]+$/, '');
    var separators = LANG === 'tr' ? '\\s+(?:veya|ya da)\\s+' : LANG === 'de' ? '\\s+oder\\s+' : LANG === 'es' ? '\\s+o\\s+' : LANG === 'pt' ? '\\s+ou\\s+' : '\\s+or\\s+';
    var match = raw.match(new RegExp('^(.+?)' + separators + '(.+)$', 'i'));
    if (!match) return null;
    var clean = function (value) { return value.trim().replace(/^[¿¡]+/, '').replace(/^(?:should\s+i\s+|do\s+i\s+|to\s+|sollte?\s+ich\s+|deber[ií]a\s+|debo\s+|devo\s+)/i, '').replace(/[?!.]+$/, ''); };
    var a = clean(match[1]);
    var b = clean(match[2]);
    return a && b ? [a, b] : null;
  }
  function slotLabels() {
    var slots = (SLOTS[answerObj().kind] || SLOTS.pattern).map(t);
    var paths = answerObj().kind === 'crossroads' ? extractTwoPaths(s.question) : null;
    if (paths) {
      slots[1] = tf('Path A — {path}', { path: paths[0] });
      slots[2] = tf('Path B — {path}', { path: paths[1] });
    }
    return slots;
  }
  function drawCastNow() {
    var ans = answerObj();
    var pool = RUNES.map(function (_, i) { return i; });
    var sd = seed((s.question || 'x') + s.focus + ans.id + Date.now());
    function rnd() { sd = (sd * 1664525 + 1013904223) >>> 0; return sd / 4294967296; }
    var out = [];
    for (var k = 0; k < ans.spread; k++) {
      var idx = Math.floor(rnd() * pool.length);
      var runeIndex = pool.splice(idx, 1)[0];
      out.push({ i: runeIndex, rev: !NON_REVERSIBLE[runeIndex] && rnd() < 0.38 });
    }
    return out;
  }

  /* ------------ computed values (design formulas) ------------ */
  function computeVals() {
    var cast = s.cast || [];
    var ans = answerObj();
    var slots = slotLabels();
    var nm = names();
    var rec = recommendIndex();
    var hasTier = s.tier !== null && s.tier !== undefined;
    var recIdx = rec >= 0 ? rec : 1;
    var hasCast = cast.length > 0 && !s.casting;
    var formOpen = s.editing || (!hasCast && !s.casting);
    var sq = shortQ();
    var focusLabel = focusLabelText();
    var focusChosen = !!s.focus && s.focus !== 'other';
    var sel = function (on) { return { border: on ? '#D9BC7E' : '#3A3450', bg: on ? '#262235' : '#1D1A28' }; };
    var fulfilmentText = t('Your written reading is based on your exact rune cast and question.');
    var deliveryText = t('Written by hand; most readings arrive by email and secure reading page within 90 minutes. On busy days it can take up to 24 hours. Nothing ships.');
    var questionValid = questionIsValid();
    var tierIdx = hasTier ? s.tier : recIdx;
    var marketWaiting = !s.marketReady && !s.marketError;
    var stale = castIsStale();
    var vals = {
      isDesktop: !s.mobile,
      formOpen: formOpen, summaryOpen: !formOpen && hasCast, casting: s.casting, hasCast: hasCast,
      hasTier: hasTier && hasCast, showStickyBar: hasCast, showReviews: false,
      focusCols: s.mobile ? 'repeat(2,minmax(0,1fr))' : 'repeat(3,minmax(0,1fr))',
      qPlaceholder: t(QPH[s.focus] || QPH.other),
      question: s.question,
      qCount: String((s.question || '').length) + ' / 220',
      questionInvalid: s.validationShown && !questionValid ? 'true' : 'false',
      questionError: s.validationShown && !questionValid ? tf('Write one focused question (at least {min} characters) to reveal your reading.', { min: MIN_QUESTION }) : '',
      unsureBorder: s.auto ? '#D9BC7E' : '#3A3450',
      unsureBg: s.auto ? '#262235' : 'transparent',
      spreadAnnounce: tf('We selected a {spread} for your question.', { spread: t(ans.note) }),
      sessionLine: (focusChosen ? focusLabel + ' · ' : '') + t(ans.label) + ' · ' + t(ans.note) + (sq ? ' · ' + sq : ''),
      castMeta: t(ans.note) + (focusChosen ? ' · ' + focusLabel : ''),
      questionDisplay: (s.question || '').trim(),
      theme: (s.server && firstSentence(s.server.theme)) || themeText(cast),
      openQuestion: hasCast ? openQuestionText() : '',
      fulfilmentText: fulfilmentText,
      deliveryText: deliveryText,
      /* The main button always says what a tap does: ask first, wait for the price, retry it, or pay. */
      checkoutCta: s.checkoutBusy ? t('Adding your reading securely…')
        : (!hasCast ? t('Start with your question')
          : (stale ? t('Reveal my free reading') : s.marketError ? marketText('retry')
            : (marketWaiting ? marketText('checking') : t('Continue to secure checkout') + ' — ' + TIER_BASE[tierIdx].price))),
      checkoutDisabled: s.checkoutBusy ? 'true' : 'false',
      checkoutBusy: s.checkoutBusy ? 'true' : 'false',
      orderRef: 'DA‑' + String(seed((s.question || 'x') + s.focus)).slice(0, 6),
      selectedName: hasTier ? nm[s.tier] : '—',
      selectedPrice: hasTier ? TIER_BASE[s.tier].price : '—',
      barLabel: cast.length ? t('Your cast') + ' · ' + cast.map(function (c) { return RUNES[c.i][1] + (c.rev ? ' ' + t('Reversed') : ''); }).join(' · ') : t('Your cast'),
      barTitle: hasTier
        ? t('Selected:') + ' ' + nm[s.tier] + ' — ' + TIER_BASE[s.tier].price
        : t('Recommended for your question:') + ' ' + nm[recIdx] + ' — ' + TIER_BASE[recIdx].price,
      barCta: s.checkoutBusy ? t('Adding securely…')
        : (stale ? t('Reveal my free reading') : s.marketError ? marketText('retry')
          : (marketWaiting ? marketText('checking') : nm[tierIdx] + ' · ' + TIER_BASE[tierIdx].price + ' · ' + t('Continue'))),
      currencyNote: s.marketError
        ? marketText('unavailable')
        : (s.marketReady ? tf('Current market: {currency} · prices update automatically for your region.', { currency: MARKET_CURRENCY }) : marketText('checking')),
      showMarketRetry: s.marketError,
      marketRetry: marketText('retry'),
      leadReview: REVIEWS[0]
    };
    vals.miniTiers = nm.map(function (n, i) {
      var miniDisabled = !s.marketReady || !TIER_BASE[i].available;
      return {
        name: n, price: TIER_BASE[i].price,
        border: s.tier === i ? '#D9BC7E' : '#3A3450',
        bg: s.tier === i ? '#262235' : 'transparent',
        disabled: miniDisabled ? 'true' : 'false',
        tabindex: miniDisabled ? '-1' : '0'
      };
    });
    vals.foci = FOCI.map(function (f) {
      var on = s.focus === f.id;
      var e = sel(on);
      return Object.assign({}, f, e, {
        label: t(f.label), hint: t(f.hint),
        selected: on, checked: on ? 'true' : 'false',
        shadow: on ? '0 2px 10px rgba(0,0,0,0.30)' : 'none',
        glyphColor: '#E3C98F'
      });
    });
    vals.answers = ANSWERS.map(function (a) {
      var on = !s.auto && s.answer === a.id;
      var e = sel(on);
      return Object.assign({}, a, e, { label: t(a.label), note: t(a.note), selected: on, checked: on ? 'true' : 'false' });
    });
    vals.timeframes = TIMEFRAMES.map(function (timeframe) {
      var on = s.timeframe === timeframe;
      var e = sel(on);
      return { label: t(timeframe), border: e.border, bg: e.bg, checked: on ? 'true' : 'false' };
    });
    vals.cast = cast.map(function (c, k) {
      return {
        glyph: RUNES[c.i][0],
        name: RUNES[c.i][1] + (c.rev ? ' ' + t('reversed') : ''),
        meaning: runeMeaning(c),
        orientation: c.rev ? t('Reversed') : t('Upright'),
        tagColor: c.rev ? '#E6E1EC' : '#E3C98F',
        transform: c.rev ? 'rotate(180deg)' : 'none',
        slot: slots[k] || ('0' + (k + 1))
      };
    });
    vals.method = [
      ['01','Anchor','What is actually shaping the situation now.','ᛜ'],
      ['02','Gate','The condition that can change its direction.','ᚦ'],
      ['03','Crossroads','The paths genuinely available to you.','ᛖ'],
      ['04','Move','The action that is inside your control.','ᚱ'],
      ['05','Compass','What to watch over the coming days.','ᛊ']
    ].map(function (m, i) {
      return { n:m[0], name:t(m[1]), desc:t(m[2]), glyph:m[3], hue:'#E3C98F' };
    });
    vals.tiers = TIER_BASE.map(function (tier, i) {
      var on = s.tier === i;
      var isRec = rec === i;
      return Object.assign({}, tier, {
        name: nm[i],
        accent: ACCENT[i],
        bg: on ? '#262235' : '#1D1A28',
        checked: on ? 'true' : 'false',
        border: on ? '#D9BC7E' : (isRec ? 'rgba(217,188,126,0.45)' : '#3A3450'),
        shadow: on ? '0 10px 28px rgba(0,0,0,0.35)' : 'none',
        showBadge: isRec, badge: recommendationBadge(i),
        bestFor: t(tier.bestFor),
        words: t(tier.words),
        delivery: t('Email + private reading link · one-time payment'),
        cta: on ? t('Selected ✓') : t('Choose this reading'),
        ctaBg: on ? '#D9BC7E' : 'transparent',
        ctaColor: on ? '#1A1408' : '#F3EFE6',
        ctaBorder: on ? '#D9BC7E' : '#3A3450',
        disabled: (!s.marketReady || !tier.available) ? 'true' : 'false',
        features: tier.features.map(t)
      });
    });
    vals.tableHeads = nm.slice();
    vals.tableRows = TABLE.map(function (r) {
      return {
        label: t(r[0]),
        c1: r[1] ? '✓' : '—', c1c: r[1] ? '#E3C98F' : '#E6E1EC',
        c2: r[2] ? '✓' : '—', c2c: r[2] ? '#E3C98F' : '#E6E1EC',
        c3: r[3] ? '✓' : '—', c3c: r[3] ? '#E3C98F' : '#E6E1EC'
      };
    });
    vals.summaryRows = [
      { label:t('Your question'), value:(s.question || '').trim() || '—', editable:true },
      { label:t('Focus'), value:focusLabel, editable:true },
      { label:t('Answer type'), value:t(ans.label), editable:true },
      { label:t('Your cast'), value: cast.map(function (c) { return RUNES[c.i][1] + (c.rev ? ' ' + t('Reversed') : ''); }).join(' · ') || '—', editable:false },
      { label:t('Delivery'), value:deliveryText, editable:false }
    ];
    vals.faqs = FAQS.map(function (f, i) {
      return {
        q: t(f[0]),
        a: i === 0 ? fulfilmentText : (i === 1 ? deliveryText + ' ' + t('Nothing else is sent unless you ask for it.') : t(f[1])),
        open: !!s.openFaqs[i], expanded: s.openFaqs[i] ? 'true' : 'false',
        sign: s.openFaqs[i] ? '−' : '+'
      };
    });
    vals.reviews = REVIEWS.map(function (review) { return { quote:t(review.quote), who:t(review.who), tier:t(review.tier) }; });
    return vals;
  }

  /* ------------ renderer ------------ */
  function resolvePath(vals, item, path) {
    /* primitive list items (e.g. tier feature strings) bind as the item itself */
    if (item != null && typeof item !== 'object' && path.indexOf('.') === -1) return item;
    if (item && path.indexOf('.') > -1) {
      var key = path.split('.').slice(1).join('.');
      var v = item;
      key.split('.').forEach(function (p) { v = v == null ? v : v[p]; });
      if (v !== undefined) return v;
    }
    var out = vals;
    path.split('.').forEach(function (p) { out = out == null ? out : out[p]; });
    return out;
  }
  function applyBindings(scope, vals, item) {
    /* global pass must not wipe list-item fills */
    function skip(el) { return !item && el.closest('[data-rv2-item]'); }
    scope.querySelectorAll('[data-rv2-bind]').forEach(function (el) {
      if (skip(el)) return;
      var v = resolvePath(vals, item, el.getAttribute('data-rv2-bind'));
      el.textContent = v == null ? '' : String(v);
    });
    scope.querySelectorAll('*').forEach(function (el) {
      if (skip(el)) return;
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-rv2-attr-') !== 0) return;
        var real = attr.name.slice('data-rv2-attr-'.length);
        var value = attr.value.replace(/%%([\w.]+)%%/g, function (_, key) {
          var v = resolvePath(vals, item, key);
          return v == null ? '' : String(v);
        });
        if (real === 'value') { if (el.value !== value) el.value = value; }
        else if (real === 'disabled') {
          el.disabled = value === 'true';
          el.setAttribute('aria-disabled', value === 'true' ? 'true' : 'false');
        } else el.setAttribute(real, value);
      });
    });
    scope.querySelectorAll('[data-rv2-ifitem]').forEach(function (el) {
      if (skip(el)) return;
      var key = el.getAttribute('data-rv2-ifitem');
      var neg = key.charAt(0) === '!';
      var v = resolvePath(vals, item, neg ? key.slice(1) : key);
      el.style.display = (neg ? !v : !!v) ? 'contents' : 'none';
    });
    if (item != null) {
      /* nested loops, e.g. tier features */
      scope.querySelectorAll('[data-rv2-list]').forEach(function (h) {
        var nm = h.getAttribute('data-rv2-list');
        if (nm.indexOf('.') === -1) return;
        var sub = resolvePath(vals, item, nm);
        if (sub && sub.length) instantiateList(h, sub, vals);
      });
    }
  }
  function instantiateList(host, items, vals) {
    var name = host.getAttribute('data-rv2-list').split('.').pop();
    var tpl = TPL[name];
    if (!tpl) return;
    host.style.display = 'contents';
    while (host.firstChild) host.removeChild(host.firstChild);
    items.forEach(function (item, idx) {
      var node = tpl.content.cloneNode(true);
      var holder = document.createElement('div');
      holder.style.display = 'contents';
      holder.setAttribute('data-rv2-item', name);
      holder.setAttribute('data-rv2-idx', String(idx));
      holder.appendChild(node);
      applyBindings(holder, vals, item);
      host.appendChild(holder);
    });
  }
  var TPL = {};
  document.querySelectorAll('template[data-rv2-tpl]').forEach(function (t) {
    TPL[t.getAttribute('data-rv2-tpl')] = t;
  });
  function render() {
    var vals = computeVals();
    document.querySelectorAll('[data-rv2-if]').forEach(function (el) {
      var key = el.getAttribute('data-rv2-if');
      var neg = key.charAt(0) === '!';
      var v = vals[neg ? key.slice(1) : key];
      el.style.display = (neg ? !v : !!v) ? 'contents' : 'none';
    });
    document.querySelectorAll('[data-rv2-list]').forEach(function (host) {
      if (host.closest('[data-rv2-item]')) return; /* nested: filled per item */
      var name = host.getAttribute('data-rv2-list');
      instantiateList(host, vals[name] || [], vals);
    });
    applyBindings(document, vals, null);
    var q = document.querySelector('textarea[data-rv2-question]');
    if (q && q.value !== s.question) q.value = s.question;
    if (q) q.setAttribute('aria-invalid', vals.questionInvalid);
    var checkoutStatus = document.querySelector('[data-rv2-checkout-status]');
    if (checkoutStatus && !checkoutStatus.textContent.trim()) checkoutStatus.style.display = 'none';
    /* fixed bar sayfa sonunu örtmesin */
    var barEl = document.querySelector('[data-screen-label="Sticky offer bar"]');
    document.body.style.paddingBottom = vals.showStickyBar && barEl ? Math.ceil(barEl.getBoundingClientRect().height + 8) + 'px' : '';
    persistState();
  }

  /* ------------ server reading + checkout bridge ------------ */
  function visitorId() {
    try {
      var k = 'rv2_visitor';
      var v = localStorage.getItem(k);
      if (!v) {
        var b = new Uint8Array(12); crypto.getRandomValues(b);
        v = 'visitor_rv2_' + Array.prototype.map.call(b, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
        localStorage.setItem(k, v);
      }
      return v;
    } catch (_) { return 'visitor_rv2_' + Date.now().toString(16); }
  }
  function track(name, data) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ page_funnel: 'rune-v2' }, data || {})); } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
  }
  function requestServerReading() {
    var ans = answerObj();
    var body = {
      focus: s.focus || 'other', answerKind: ans.kind, timeframe: s.timeframe, locale: LOCALE,
      question: s.question, visitorId: visitorId(), readingId: s.readingId,
      cast: s.cast.map(function (c) { return { name: RUNES[c.i][1], orientation: c.rev ? 'reversed' : 'upright' }; })
    };
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ac ? setTimeout(function () { ac.abort(); }, 14000) : 0;
    return fetch(API_BASE + '/free-cast', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ac ? ac.signal : undefined
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .finally(function () { if (timer) clearTimeout(timer); });
  }
  function showCheckoutStatus(message, isError) {
    var status = document.querySelector('[data-rv2-checkout-status]');
    if (!status) return;
    status.textContent = message || '';
    status.style.display = message ? 'block' : 'none';
    status.style.color = isError ? '#F4B4BC' : '#7FD1A8';
    if (message && isError) {
      try { status.focus({ preventScroll: true }); } catch (_) {}
      /* A failed one-tap checkout from the sticky bar starts far above this line; bring it on screen. */
      var box = status.getBoundingClientRect();
      if (box.top < 72 || box.bottom > window.innerHeight - 8) {
        try { status.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) { status.scrollIntoView(); }
      }
    }
  }
  function castProperty() {
    var slots = slotLabels();
    return s.cast.map(function (c, index) {
      return (slots[index] || tf('Rune {number}', { number: index + 1 })) + ': ' + RUNES[c.i][1] + ' (' + (c.rev ? t('reversed') : t('upright')) + ')';
    }).join('; ');
  }
  function canonicalRuneCast(answer) {
    var positions = SLOT_IDS[answer.kind] || [];
    return s.cast.map(function (c, index) {
      return {
        positionId: positions[index] || '',
        runeIndex: c.i,
        name: RUNES[c.i][1],
        orientation: c.rev ? 'reversed' : 'upright'
      };
    });
  }
  function canonicalRuneCastProperty(cast) {
    return (cast || []).map(function (item) {
      return [item.positionId, item.runeIndex, item.name, item.orientation].join(':');
    }).join(';');
  }
  function checkoutContractIsValid() {
    var ans = answerObj();
    var slots = SLOTS[ans.kind] || [];
    var positionIds = SLOT_IDS[ans.kind] || [];
    if (!questionIsValid() || !ans || !slots.length || positionIds.length !== slots.length || s.cast.length !== slots.length) return false;
    if (!FOCI.some(function (focus) { return focus.id === s.focus; }) || !TIMEFRAME_IDS[s.timeframe]) return false;
    if (!s.castContract || s.castContract !== castInputContract()) return false;
    var usedRunes = {};
    for (var index = 0; index < s.cast.length; index += 1) {
      var rune = s.cast[index];
      if (!rune || !Number.isInteger(rune.i) || !RUNES[rune.i] || typeof rune.rev !== 'boolean') return false;
      if (rune.rev && NON_REVERSIBLE[rune.i]) return false;
      if (usedRunes[rune.i]) return false;
      usedRunes[rune.i] = true;
    }
    return castProperty().split('; ').length === slots.length;
  }
  function checkoutSnapshot() {
    var ans = answerObj();
    var cast = castProperty();
    var canonicalCast = canonicalRuneCast(ans);
    var focus = focusLabelText();
    var context = ['Focus: ' + focus, 'Answer type: ' + t(ans.label), 'Timeframe: ' + t(s.timeframe), 'Exact cast: ' + cast].join('; ');
    return {
      version: 'reading-snapshot-v2', type: 'Rune Reading', question: (s.question || '').trim(), context: context,
      signals: cast, cards: '', spread: ans.kind + ' spread',
      scope: 'Interpret this exact rune cast for the customer question and selected spread. Use symbolic, reflective guidance; do not promise a fixed future.',
      confidence: 'Unique runes drawn without replacement from the 24-rune Elder Futhark set; symmetric runes remain upright.',
      focus: focus, tool: 'Rune Reading', readingId: s.readingId,
      focusId: s.focus, answerId: ans.id, answerKind: ans.kind, timeframeId: TIMEFRAME_IDS[s.timeframe], cast: canonicalCast,
      curiosityQuestion: openQuestionText(),
      presentationVariant: RUNE_PRESENTATION_VERSION
    };
  }
  function checkoutProperties(intent, displayedQuote, signedQuote) {
    var ans = answerObj();
    var snapshot = checkoutSnapshot();
    var signedLocale = intent && intent.localeContext || {};
    return {
      'Reading Type': 'Rune Reading',
      'Your Question': (s.question || '').trim(),
      'Reading Focus': focusLabelText(),
      'Answer Type': t(ans.label),
      'Timeframe': t(s.timeframe),
      '_Rune Cast': snapshot.signals,
      '_Rune Focus ID': snapshot.focusId,
      '_Rune Answer ID': snapshot.answerId,
      '_Rune Answer Kind': snapshot.answerKind,
      '_Rune Timeframe ID': snapshot.timeframeId,
      '_Rune Canonical Cast': canonicalRuneCastProperty(snapshot.cast),
      '_Spread': ans.kind + ' spread',
      '_Intent Kind': 'shared_tool',
      '_Result Signals': snapshot.signals,
      '_Reading Scope': snapshot.scope,
      '_Calculation Confidence': snapshot.confidence,
      '_Context': snapshot.context,
      '_Focus': snapshot.focus,
      '_Tool': 'https://deckaura.com/pages/rune-reading',
      '_Tool Type': 'Rune Reading',
      '_Tool Page': '/pages/rune-reading',
      '_Reading ID': s.readingId,
      '_Funnel Version': SHARED_FUNNEL_VERSION,
      '_Contract Version': 'rune-checkout-v2',
      '_Offer Variant': 'enterprise_shared_v1',
      '_Snapshot Version': snapshot.version,
      '_Presentation Variant': snapshot.presentationVariant,
      '_Source': '/pages/rune-reading',
      '_Checkout Intent': intent.intentId,
      '_Checkout Signature': intent.signature,
      '_Selected Package': intent.tier,
      '_Snapshot Hash': intent.snapshotHash,
      '_Displayed Quote Cents': String(displayedQuote.priceCents),
      '_Displayed Quote Currency': displayedQuote.currency,
      '_Displayed Quote Country': displayedQuote.country,
      '_Signed Quote Cents': String(signedQuote.priceCents),
      '_Signed Quote Currency': signedQuote.currency,
      '_Signed Quote Country': signedQuote.country,
      '_Language': String(signedLocale.language || LANG).toLowerCase(),
      '_Locale': String(signedLocale.locale || LOCALE),
      '_Country': String(signedLocale.country || signedQuote.country).toUpperCase(),
      '_Currency': String(signedLocale.currency || signedQuote.currency).toUpperCase(),
      '_Market': String(signedLocale.market || signedQuote.country).toLowerCase()
    };
  }
  function newAttemptKey() {
    try { if (crypto.randomUUID) return 'rune_' + crypto.randomUUID().replace(/-/g, ''); } catch (_) {}
    return 'rune_' + Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeoutMs || 12000) : 0;
    var request = Object.assign({}, options || {});
    if (controller) request.signal = controller.signal;
    return fetch(url, request).finally(function () { if (timer) clearTimeout(timer); });
  }
  function createCheckoutIntent(variantId, attemptKey, tierIndex) {
    if (!s.marketReady || s.marketError || !/^[A-Z]{3}$/.test(MARKET_CURRENCY) || !/^[A-Z]{2}$/.test(MARKET_COUNTRY)
      || !TIER_BASE[tierIndex] || !TIER_BASE[tierIndex].available || !Number.isInteger(TIER_BASE[tierIndex].priceCents) || TIER_BASE[tierIndex].priceCents <= 0) {
      return Promise.reject(new Error('market_price_unavailable'));
    }
    var snapshot = checkoutSnapshot();
    var displayedQuote = {
      variantId: String(variantId), sku: RUNE_SKUS[tierIndex], priceCents: TIER_BASE[tierIndex].priceCents,
      currency: MARKET_CURRENCY, country: MARKET_COUNTRY
    };
    var body = {
      kind: 'shared_tool', funnelVersion: SHARED_FUNNEL_VERSION, offerVariant: 'enterprise_shared_v1',
      snapshotVersion: snapshot.version, page: '/pages/rune-reading', toolType: 'Rune Reading',
      tier: RAIL_TIERS[tierIndex], expectedVariantId: String(variantId), idempotencyKey: attemptKey,
      locale: LOCALE, country: MARKET_COUNTRY, currency: MARKET_CURRENCY, market: MARKET_COUNTRY.toLowerCase(),
      question: snapshot.question, readingId: s.readingId, snapshot: snapshot, displayedQuote: displayedQuote
    };
    return fetchWithTimeout(INTENT_ENDPOINT, {
      method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }, 14000).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (response.status === 409 && payload.confirmationRequired && payload.checkoutQuote) {
          var changedQuote = payload.checkoutQuote;
          if (String(changedQuote.variantId || '') !== String(variantId) || String(changedQuote.sku || '').toUpperCase() !== RUNE_SKUS[tierIndex]
            || !Number.isInteger(Number(changedQuote.priceCents)) || Number(changedQuote.priceCents) <= 0
            || !/^[A-Z]{3}$/.test(String(changedQuote.currency || '')) || !/^[A-Z]{2}$/.test(String(changedQuote.country || ''))) throw new Error('checkout_intent_invalid');
          var changed = new Error('price_confirmation_required'); changed.quote = changedQuote; throw changed;
        }
        if (!response.ok) { var failed = new Error(payload.code || payload.error || 'checkout_intent_unavailable'); failed.status = response.status; throw failed; }
        var quote = payload.checkoutQuote || {};
        if (!payload.ok || !/^[0-9a-f-]{36}$/i.test(String(payload.intentId || '')) || !/^[a-f0-9]{64}$/i.test(String(payload.signature || ''))
          || String(payload.variantId) !== String(variantId) || String(payload.sku || '').toUpperCase() !== RUNE_SKUS[tierIndex]
          || !/^[a-f0-9]{64}$/i.test(String(payload.snapshotHash || '')) || !payload.expiresAt || Date.parse(payload.expiresAt) <= Date.now()
          || String(quote.intentId || '') !== String(payload.intentId) || String(quote.snapshotHash || '') !== String(payload.snapshotHash)
          || String(quote.variantId || '') !== String(variantId) || String(quote.sku || '').toUpperCase() !== RUNE_SKUS[tierIndex]
          || !Number.isInteger(Number(quote.priceCents)) || Number(quote.priceCents) <= 0 || !/^[A-Z]{3}$/.test(String(quote.currency || '')) || !/^[A-Z]{2}$/.test(String(quote.country || ''))) {
          throw new Error('checkout_intent_invalid');
        }
        return { intent: payload, displayedQuote: displayedQuote, signedQuote: quote, snapshot: snapshot, readingId: snapshot.readingId, tierIndex: tierIndex };
      });
    });
  }
  function isReadingItem(item) {
    var properties = item && item.properties || {};
    return RUNE_SKUS.indexOf(String(item && item.sku || '').toUpperCase()) !== -1 || !!properties['_Checkout Intent'] || !!properties['_Reading ID'];
  }
  function checkoutLineMatches(cart, line, variantId, contract) {
    var properties = line && line.properties || {};
    var signed = contract && contract.signedQuote || {};
    var displayed = contract && contract.displayedQuote || {};
    var snapshot = contract && contract.snapshot || {};
    var signedCents = Number(signed.priceCents), linePrice = Number(line && line.price), finalPrice = Number(line && line.final_price);
    return !!line
      && String(cart && cart.currency || '').toUpperCase() === String(signed.currency || '').toUpperCase()
      && String(line.variant_id || line.id || '') === String(variantId)
      && String(line.sku || '').toUpperCase() === RUNE_SKUS[contract.tierIndex]
      && Number(line.quantity) === 1
      && line.requires_shipping === false
      && Number.isInteger(signedCents) && signedCents > 0
      && Number.isInteger(linePrice) && linePrice === signedCents
      && Number.isInteger(finalPrice) && finalPrice > 0 && finalPrice <= linePrice
      && String(properties['_Checkout Intent'] || '') === String(contract.intent.intentId)
      && String(properties['_Checkout Signature'] || '') === String(contract.intent.signature)
      && String(properties['_Snapshot Hash'] || '') === String(contract.intent.snapshotHash)
      && String(properties['_Selected Package'] || '') === String(contract.intent.tier)
      && String(properties['_Reading ID'] || '') === String(contract.readingId)
      && String(properties['_Displayed Quote Cents'] || '') === String(displayed.priceCents)
      && String(properties['_Displayed Quote Currency'] || '') === String(displayed.currency)
      && String(properties['_Displayed Quote Country'] || '') === String(displayed.country)
      && String(properties['_Signed Quote Cents'] || '') === String(signed.priceCents)
      && String(properties['_Signed Quote Currency'] || '') === String(signed.currency)
      && String(properties['_Signed Quote Country'] || '') === String(signed.country)
      && String(properties['_Rune Focus ID'] || '') === String(snapshot.focusId || '')
      && String(properties['_Rune Answer ID'] || '') === String(snapshot.answerId || '')
      && String(properties['_Rune Answer Kind'] || '') === String(snapshot.answerKind || '')
      && String(properties['_Rune Timeframe ID'] || '') === String(snapshot.timeframeId || '')
      && String(properties['_Rune Canonical Cast'] || '') === canonicalRuneCastProperty(snapshot.cast);
  }
  function fetchCart() {
    return fetchWithTimeout(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' }, 10000)
      .then(function (response) { if (!response.ok) throw new Error('cart_read_failed'); return response.json(); });
  }
  function normalizeReadingCart() {
    return fetchCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) { if (isReadingItem(item) && item.key) updates[item.key] = 0; });
      if (!Object.keys(updates).length) return cart;
      return fetchWithTimeout(shopRoot() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }, 10000).then(function (response) { if (!response.ok) throw new Error('reading_cart_normalization_failed'); return response.json(); })
        .then(function (updated) { if ((updated.items || []).some(isReadingItem)) throw new Error('reading_cart_normalization_failed'); return updated; });
    });
  }
  function parseResponseError(response) {
    return response.json().then(function (body) {
      return body && (body.description || body.message) ? (body.description || body.message) : t('The reading could not be added. Please try again.');
    }).catch(function () { return t('The reading could not be added. Please try again.'); });
  }
  function checkoutSelected(via) {
    if (s.checkoutBusy) return;
    if (!checkoutContractIsValid() || s.tier == null || !RUNE_VARIANTS[s.tier]) {
      showCheckoutStatus(t('Your question or rune cast no longer matches the selected spread. Reveal a fresh cast before checkout.'), true);
      return;
    }
    if (!s.marketReady || s.marketError) {
      showCheckoutStatus(s.marketError ? marketText('unavailable') : marketText('checking'), true);
      return;
    }
    if (!TIER_BASE[s.tier].available) {
      showCheckoutStatus(t('That reading level is temporarily unavailable. Please choose another level.'), true);
      return;
    }
    s.checkoutBusy = true;
    showCheckoutStatus(t('Adding your selected reading securely…'), false);
    render();
    var checkoutTier = s.tier;
    var variantId = RUNE_VARIANTS[checkoutTier];
    var attemptKey = newAttemptKey();
    createCheckoutIntent(variantId, attemptKey, checkoutTier).then(function (contract) {
      if (contract.displayedQuote.priceCents !== Number(contract.signedQuote.priceCents)
        || contract.displayedQuote.currency !== contract.signedQuote.currency
        || contract.displayedQuote.country !== contract.signedQuote.country) {
        var changed = new Error('price_confirmation_required'); changed.quote = contract.signedQuote; throw changed;
      }
      return normalizeReadingCart().then(function () {
        return fetchWithTimeout(shopRoot() + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: checkoutProperties(contract.intent, contract.displayedQuote, contract.signedQuote) }] })
        }, 12000).then(function (response) {
          if (response.ok) return response.json();
          return parseResponseError(response).then(function (message) { throw new Error(message); });
        }).then(function () { return fetchCart(); }).then(function (cart) {
          var readings = (cart.items || []).filter(isReadingItem);
          if (readings.length !== 1 || !checkoutLineMatches(cart, readings[0], variantId, contract)) throw new Error('cart_contract_mismatch');
          return readings[0];
        });
      });
    }).then(function () {
      track('rune_v2_checkout_ready', { tier: RAIL_TIERS[checkoutTier], via: via || 'summary' });
      window.location.assign(shopRoot() + 'checkout');
    }).catch(function (error) {
      var priceConfirmation = error && error.message === 'price_confirmation_required' && error.quote;
      var cartMismatch = error && error.message === 'cart_contract_mismatch';
      if (priceConfirmation) {
        TIER_BASE[checkoutTier].priceCents = Number(error.quote.priceCents);
        MARKET_CURRENCY = String(error.quote.currency || MARKET_CURRENCY);
        MARKET_COUNTRY = String(error.quote.country || MARKET_COUNTRY);
        TIER_BASE[checkoutTier].price = formatMarketMoney(TIER_BASE[checkoutTier].priceCents, MARKET_CURRENCY);
        TIER_BASE[checkoutTier].available = true;
      }
      s.checkoutBusy = false;
      if (cartMismatch) {
        s.marketReady = false; s.marketError = false; s.tier = null; clearMarketPrices(); render();
        showCheckoutStatus(marketText('cartMismatch'), true);
        normalizeReadingCart().then(function () { return hydrateMarketPrices(); }).catch(function () {
          s.marketReady = false; s.marketError = true; clearMarketPrices(); render();
        });
      } else {
        render();
        if (!priceConfirmation) normalizeReadingCart().catch(function () {});
        showCheckoutStatus(priceConfirmation
          ? tf('Price updated to {price}. Select continue again to confirm.', { price: TIER_BASE[checkoutTier].price })
          : t('Checkout could not start. Please try again.'), true);
      }
      track('rune_v2_checkout_failed', { tier: RAIL_TIERS[checkoutTier] || '', via: via || 'summary' });
    });
  }
  var marketRequestId = 0;
  var marketLoadPromise = null;
  function clearMarketPrices() {
    TIER_BASE.forEach(function (tier) { tier.price = '—'; tier.priceCents = 0; tier.available = false; });
  }
  function hydrateMarketPrices() {
    if (marketLoadPromise) return marketLoadPromise;
    var requestId = ++marketRequestId;
    s.marketReady = false; s.marketError = false; clearMarketPrices(); render();
    var operation = fetchWithTimeout(shopRoot() + 'cart.js', { credentials:'same-origin', headers:{'Accept':'application/json'}, cache:'no-store' }, 10000)
      .then(function (response) { if (!response.ok) throw new Error('market_cart_unavailable'); return response.json(); })
      .then(function (cart) {
        var currency = String(cart && cart.currency || '').toUpperCase();
        var localeContext = window.DeckauraLocale || {};
        var country = '';
        try { country = String(localeContext.country || (window.Shopify && (window.Shopify.country || window.Shopify.countryCode)) || '').toUpperCase(); } catch (_) { country = String(localeContext.country || '').toUpperCase(); }
        if (!/^[A-Z]{3}$/.test(currency) || !/^[A-Z]{2}$/.test(country)) throw new Error('market_context_invalid');
        return Promise.all(RUNE_VARIANTS.map(function (id) {
          return fetchWithTimeout(shopRoot() + 'variants/' + encodeURIComponent(String(id)) + '.js', { credentials:'same-origin', headers:{'Accept':'application/json'}, cache:'no-store' }, 10000)
            .then(function (response) { if (!response.ok) throw new Error('market_variant_unavailable'); return response.json(); });
        })).then(function (variants) { return { currency:currency, country:country, variants:variants }; });
      }).then(function (market) {
        if (requestId !== marketRequestId) return false;
        if (!Array.isArray(market.variants) || market.variants.length !== RUNE_VARIANTS.length) throw new Error('market_variant_contract');
        var normalized = market.variants.map(function (variant, index) {
          var price = Number(variant && variant.price);
          if (!variant || String(variant.id || '') !== String(RUNE_VARIANTS[index]) || String(variant.sku || '').toUpperCase() !== RUNE_SKUS[index]
            || typeof variant.available !== 'boolean' || variant.requires_shipping !== false || !Number.isInteger(price) || price <= 0) throw new Error('market_variant_contract');
          return { priceCents:price, available:variant.available === true };
        });
        MARKET_CURRENCY = market.currency; MARKET_COUNTRY = market.country;
        normalized.forEach(function (tier, index) {
          TIER_BASE[index].priceCents = tier.priceCents;
          TIER_BASE[index].price = formatMarketMoney(tier.priceCents, MARKET_CURRENCY);
          TIER_BASE[index].available = tier.available;
        });
        s.marketReady = true; s.marketError = false; render(); return true;
      }).catch(function () {
        if (requestId !== marketRequestId) return false;
        s.marketReady = false; s.marketError = true; clearMarketPrices(); render(); return false;
      });
    marketLoadPromise = operation.finally(function () { if (requestId === marketRequestId) marketLoadPromise = null; });
    return marketLoadPromise;
  }

  /* ------------ flow ------------ */
  function scrollWithHeaderOffset(target, instant) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - 80;
    if (instant) {
      var root = document.documentElement;
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, Math.max(0, top));
      root.style.scrollBehavior = previous;
      return;
    }
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  function placeResultInView(target) {
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (err) {
      try { target.focus(); } catch (focusErr) {}
    }
    var root = document.documentElement;
    var previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
    var rect = target.getBoundingClientRect();
    window.scrollTo(0, Math.max(0, window.scrollY + rect.top - 80));
    root.style.scrollBehavior = previous;
  }
  function scrollToStep(step) {
    if (!s.mobile) return;
    var target = document.querySelector('[data-rv2-step="' + step + '"]');
    window.setTimeout(function () { scrollWithHeaderOffset(target); }, 80);
  }
  function goToQuestion(focusField) {
    window.setTimeout(function () {
      scrollWithHeaderOffset(document.querySelector('[data-rv2-step="question"]'));
      var field = document.querySelector('textarea[data-rv2-question]');
      if (focusField && field) { try { field.focus({ preventScroll: true }); } catch (_) {} }
    }, 60);
  }
  function startCheckout(via) {
    if (s.marketError) { showCheckoutStatus(marketText('checking'), false); hydrateMarketPrices(); return; }
    /* The recommended tier is preselected after the cast; report it as chosen when checkout starts on it, as before. */
    if (s.tier == null || s.tierAuto) {
      if (s.tier == null) s.tier = recommendIndex();
      s.tierAuto = false;
      track('rune_v2_tier_selected', { tier: RAIL_TIERS[s.tier], via: via });
    }
    track('rune_v2_checkout_started', { tier: RAIL_TIERS[s.tier] || String(s.tier), via: via });
    checkoutSelected(via);
  }
  function reveal() {
    if (s.busy) return;
    if (!questionIsValid()) {
      s.validationShown = true;
      render();
      var invalid = document.querySelector('textarea[data-rv2-question]');
      if (invalid) {
        invalid.focus({ preventScroll: true });
        scrollWithHeaderOffset(invalid);
      }
      return;
    }
    if (s.cast.length && s.castContract === castInputContract()) {
      s.editing = false;
      render();
      window.setTimeout(function () { scrollWithHeaderOffset(document.querySelector('[data-rv2-result]')); }, 60);
      return;
    }
    if (!s.focus) { s.focus = 'other'; }
    s.validationShown = false;
    s.busy = true; s.casting = true; s.editing = false;
    /* intent route readingId contract: /^[a-z0-9-]{8,80}$/i (no underscores) */
    s.readingId = 'rv2-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    s.cast = drawCastNow();
    s.castQuestion = (s.question || '').trim().toLowerCase();
    s.castContract = castInputContract();
    s.server = null;
    var funnel = document.querySelector('section[data-screen-label="Funnel"]');
    if (funnel) funnel.style.minHeight = Math.ceil(funnel.getBoundingClientRect().height) + 'px';
    render();
    track('rune_v2_cast_started', { focus: s.focus, kind: answerObj().kind });
    var started = Date.now();
    requestServerReading().then(function (res) {
      if (res && res.theme && !(LANG !== 'en' && res.servedSource === 'deterministic_design_tables')) s.server = res;
    }).then(function () {
      var wait = Math.max(0, 1100 - (Date.now() - started));
      setTimeout(function () {
        s.casting = false; s.busy = false;
        if (s.tier == null) { s.tier = recommendIndex(); s.tierAuto = true; }
        render();
        track('rune_v2_cast_revealed', { source: s.server ? s.server.servedSource : 'design_fallback' });
        var result = document.querySelector('[data-rv2-result]');
        if (funnel) funnel.style.minHeight = '';
        placeResultInView(result);
        window.setTimeout(function () { placeResultInView(result); }, 0);
        window.setTimeout(function () { placeResultInView(result); }, 120);
      }, wait);
    });
  }

  /* ------------ event delegation ------------ */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var act = t.closest('[data-rv2-act]');
    if (act) {
      var a = act.getAttribute('data-rv2-act');
      if (a === 'draw') { ev.preventDefault(); reveal(); }
      else if (a === 'edit') { s.editing = true; render(); }
      else if (a === 'reset') {
        s.cast = []; s.server = null; s.tier = null; s.question = ''; s.castQuestion = ''; s.castContract = ''; s.editing = false; s.validationShown = false;
        clearPersistedState();
        showCheckoutStatus('', false); render();
        goToQuestion(false);
      }
      else if (a === 'unsure') { s.answer = autoAnswerId(); s.auto = true; s.tier = null; render(); scrollToStep('question'); }
      else if (a === 'cleartier') { s.tier = null; showCheckoutStatus('', false); render(); scrollWithHeaderOffset(document.getElementById('readings')); }
      else if (a === 'retry-market') {
        ev.preventDefault(); showCheckoutStatus(marketText('checking'), false); hydrateMarketPrices();
      }
      else if (a === 'checkout') {
        ev.preventDefault();
        if (!s.cast.length) { goToQuestion(true); return; }
        if (castIsStale()) { reveal(); return; }
        startCheckout('summary');
      }
      else if (a === 'bar') {
        /* One tap from the result: the selected (or recommended) package goes straight to checkout. */
        ev.preventDefault();
        if (castIsStale()) { reveal(); return; }
        startCheckout('sticky_bar');
      }
      return;
    }
    var item = t.closest(
      '[data-rv2-item="foci"],' +
      '[data-rv2-item="answers"],' +
      '[data-rv2-item="timeframes"],' +
      '[data-rv2-item="tiers"],' +
      '[data-rv2-item="miniTiers"],' +
      '[data-rv2-item="faqs"],' +
      '[data-rv2-item="summaryRows"]'
    );
    if (item) {
      var listName = item.getAttribute('data-rv2-item');
      var idx = Number(item.getAttribute('data-rv2-idx'));
      if ((listName === 'tiers' || listName === 'miniTiers') && s.cast.length && (s.checkoutBusy || !s.marketReady || !TIER_BASE[idx] || !TIER_BASE[idx].available)) {
        ev.preventDefault();
        showCheckoutStatus(s.marketError ? marketText('unavailable') : marketText('checking'), !!s.marketError);
        if (!s.marketError) hydrateMarketPrices();
        return;
      }
      if (listName === 'foci') { s.focus = FOCI[idx].id; s.tier = null; track('rune_v2_focus_selected', { focus: s.focus }); render(); scrollToStep('answer'); }
      else if (listName === 'answers') { s.answer = ANSWERS[idx].id; s.auto = false; s.tier = null; track('rune_v2_answer_selected', { answer: s.answer }); render(); scrollToStep('question'); }
      else if (listName === 'timeframes') { s.timeframe = TIMEFRAMES[idx]; s.tier = null; render(); }
      else if (listName === 'tiers') {
        s.tier = idx; s.tierAuto = false;
        track('rune_v2_tier_selected', { tier: RAIL_TIERS[idx] });
        render();
        if (!s.cast.length) { goToQuestion(false); return; }
        var cta = document.querySelector('[data-rv2-act="checkout"]');
        if (cta) cta.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      else if (listName === 'miniTiers') {
        s.tier = idx; s.tierAuto = false;
        track('rune_v2_tier_selected', { tier: RAIL_TIERS[idx], via: 'sticky_bar' });
        render();
      }
      else if (listName === 'faqs') { s.openFaqs[idx] = !s.openFaqs[idx]; render(); }
      else if (listName === 'summaryRows') { s.editing = true; render(); goToQuestion(true); }
    }
  });
  document.addEventListener('input', function (ev) {
    var field = ev.target;
    if (field && field.matches && field.matches('textarea[data-rv2-question]')) {
      var wasStale = castIsStale();
      s.question = field.value.slice(0, 220);
      if (field.value !== s.question) field.value = s.question;
      if (s.auto) { s.answer = autoAnswerId(); }
      var stale = castIsStale();
      if (stale) s.tier = null;
      if (questionIsValid()) s.validationShown = false;
      var counter = document.querySelector('[data-rv2-bind="qCount"]');
      if (counter) counter.textContent = String(s.question.length) + ' / 220';
      var ann = document.querySelector('[data-rv2-bind="spreadAnnounce"]');
      if (ann) ann.textContent = tf('We selected a {spread} for your question.', { spread: t(answerObj().note) });
      field.setAttribute('aria-invalid', s.validationShown && !questionIsValid() ? 'true' : 'false');
      var error = document.querySelector('[data-rv2-bind="questionError"]');
      if (error && !s.validationShown) error.textContent = '';
      /* Re-render only when the cast flips between current and stale, so the sticky and main buttons say what a tap does. */
      if (stale !== wasStale) render(); else persistState();
    }
  });

  window.addEventListener('pagehide', persistState);
  window.addEventListener('pageshow', function () {
    s.checkoutBusy = false; s.busy = false; s.casting = false;
    render();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && s.checkoutBusy) { s.checkoutBusy = false; render(); }
  });
  restoreState();
  var refine = document.querySelector('[data-rv2-refine]');
  if (refine && ((s.focus && s.focus !== 'other') || !s.auto || s.timeframe !== 'No fixed timeframe')) refine.open = true;
  /* The sticky bar repeats the main checkout button; tuck it away while that button is on screen. */
  var mainCta = document.querySelector('[data-rv2-act="checkout"]');
  var stickyBar = document.querySelector('.rv2-sticky');
  if (mainCta && stickyBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { stickyBar.classList.toggle('rv2-sticky--tucked', entry.isIntersecting); });
    }, { threshold: 0.5 }).observe(mainCta);
  }
  render();
  hydrateMarketPrices();
  track('rune_v2_page_ready', {});
})();
